import React, { FC, SyntheticEvent, useCallback, useEffect, useRef } from 'react';
import HlsPlayer from 'react-hls-player';
import { connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';

import type { ReduxState } from 'app/redux/types';

import { selectLiveStreamPreferences } from 'app/modules/LiveStream/selectors';

import { setPipMode, toggleMutedState } from '../../actions';

type DispatchProp = {
  dispatch: Dispatch;
};

type HLSHandlerProps = {
  videoId: string;
} & ReturnType<typeof mapStateToProps>;

const HLSHandler: FC<HLSHandlerProps & DispatchProp> = ({
  videoId,
  muted,
  dispatch,
}) => {
  const playerRef = useRef<HTMLVideoElement>(null);
  const onMute = useCallback((event: SyntheticEvent<HTMLVideoElement>) => {
    dispatch(toggleMutedState(event.currentTarget.muted));
  }, []);

  const onPipMode = useCallback(() => {
    dispatch(setPipMode(true));
  }, []);

  useEffect(() => {
    playerRef.current?.addEventListener('enterpictureinpicture', onPipMode);
    return () => {
      playerRef.current?.removeEventListener('enterpictureinpicture', onPipMode);
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture()
          .catch((err) => console.error('HLSHandler exit PiP mode error: ', err));
      }
    };
  }, [playerRef.current]);

  return (
    <HlsPlayer
      playerRef={playerRef}
      src={videoId}
      width="100%"
      height="auto"
      onVolumeChange={onMute}
      muted={muted}
      controls
      controlsList="nodownload noplaybackrate"
      autoPlay />
  );
};

const mapStateToProps = (state: ReduxState) => ({
  muted: selectLiveStreamPreferences(state).muted,
});

export default connect(mapStateToProps)(HLSHandler);
